import './index.less'

$(function(){
    // 切换页面的拓客线索、智能触达等菜单
    var Element = document.createElement('div');
    var targetElement = 'home-data-logo'
    var activeElement = 'home-data-active'
    var switchElement = 'home-toke-clue'
    $('.home-data-logo > div:nth-child(1)').addClass(activeElement)
    $('.home-data-logo > div').mouseenter(function () {
        window.commonjs.switchToke(
            $(this),//当前点击的div
            Element,//添加的倒三角图标
            targetElement,//切换的目标类名
            activeElement,//选中目标类名
            switchElement,//切换的目标类名
            );
    });
})


// WEBPACK FOOTER //
// ./src/view/case/index.js